
    export default {
        props: ["addClassNeme"]
    }
